module.exports = __webpack_public_path__ + "static/img/339.7cfd4fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200513/339.jpg
// module id = Zaqm
// module chunks = 0